module.exports = __webpack_public_path__ + "static/media/shopping-bag.af2c40d7.svg";